import styled from '@emotion/styled'
import { Autocomplete, Chip, TextField } from '@mui/material'
import { colors } from '@resiliatech/birdsong'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
  width: 100%;
`

export const ImpactChipsContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-bottom: 24px;
`

export const StyledChip = styled(Chip)`
  background-color: ${colors.interactive.secondaryEnabled};
  border-radius: 100px;
  font-size: 16px;
  height: 40px;
  padding-right: 4px;
`

export const ChipInput = styled('input')`
  border: none;
  background: transparent;
  font-family: inherit;
  font-size: inherit;
  padding: 0;
  margin: 0;
  width: 80px;
  &:focus {
    outline: none;
  }
`

export const AddChipContainer = styled.div`
  display: inline-flex;
  align-items: center;
  background-color: ${colors.interactive.secondaryEnabled};
  border-radius: 100px;
  padding: 4px 12px;
  height: 40px;
`

export const ButtonContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 8px;
  align-items: center;
  width: 100%;
  margin-top: auto;
`

export const ImpactAutoComplete = styled(Autocomplete)`
  width: 100%;
  height: 100%;
`
export const AutoCompleteTextField = styled(TextField)`
  width: 200px;
`
